<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-disassemble`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M44 6a2 2 0 00-2-2H6a2 2 0 00-2 2v36a2 2 0 002 2h18v-4H8V8h32v16h4V6zM32.208 29.383c-.241-.228-.373-.296-.528-.343a.908.908 0 00-.535 0c-.177.054-.324.135-.639.45l-1.015 1.016c-.316.315-.397.462-.45.64a.908.908 0 000 .534c.053.177.134.324.45.639l4.75 4.75-4.75 4.75c-.316.316-.397.463-.45.64a.908.908 0 000 .534c.053.177.134.324.45.64l1.015 1.015c.315.315.462.397.64.45a.908.908 0 00.534 0c.177-.053.324-.135.639-.45l4.75-4.75 4.75 4.75c.316.315.463.397.64.45a.908.908 0 00.534 0c.177-.053.324-.135.64-.45l1.015-1.015c.315-.316.397-.463.45-.64a.908.908 0 000-.534c-.053-.177-.135-.324-.45-.64l-4.75-4.75 4.75-4.75c.315-.315.397-.462.45-.64a.908.908 0 000-.534c-.053-.177-.135-.324-.45-.639l-1.015-1.015c-.316-.316-.463-.397-.64-.45a.908.908 0 00-.534 0c-.177.053-.324.134-.64.45l-4.75 4.75-4.86-4.858z"/></svg>
</template>
<script>

export default {
  name: 'IconDisassemble',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
